import apiClient from "./apiClient";

const list = async (filters = {}) => {
  const params = {};

  if (filters.view) {
    params.view = filters.view;
  }

  const response = await apiClient.get("/richieste", { params });
  return response.data;
};

const getById = async (richiestaId) => {
  const response = await apiClient.get(`/richieste/${richiestaId}`);
  return response.data;
};

const create = async (payload) => {
  const response = await apiClient.post("/richieste", payload);
  return response.data;
};

const update = async (richiestaId, payload) => {
  const response = await apiClient.put(`/richieste/${richiestaId}`, payload);
  return response.data;
};

const createCheckoutSession = async (richiestaId) => {
  const response = await apiClient.post(`/payments/richieste/${richiestaId}/checkout-session`);
  return response.data;
};

const RichiesteService = {
  list,
  getById,
  create,
  update,
  createCheckoutSession,
};

export default RichiesteService;

